import { gql } from "@apollo/client"
import {
  ADDRESS_FRAGMENT,
  CLIENT_ACCESS_FRAGMENT,
  LOGIN_RESPONSE_FRAGMENT,
} from "lib/apollo/fragments"

export const LOGIN = gql`
  mutation login(
    $email: String!
    $password: String!
    $basketId: ID!
    $basketVersion: Int!
    $basket: [ItemInput!]!
    $wishlist: [ItemInput!]!
    $wishlistId: ID!
    $wishlistVersion: Int!
    $promocodes: [String!]!
    $reset: Boolean
    $referralCode: String
  ) {
    login(
      email: $email
      password: $password
      basketId: $basketId
      basketVersion: $basketVersion
      basket: $basket
      wishlist: $wishlist
      wishlistId: $wishlistId
      wishlistVersion: $wishlistVersion
      promocodes: $promocodes
      reset: $reset
      referralCode: $referralCode
    ) {
      ...LoginResponseFragment
    }
  }
  ${LOGIN_RESPONSE_FRAGMENT}
`

export const ANONYMOUS_LOGIN = gql`
  mutation anonymousLogin(
    $basket: [ItemInput!]!
    $wishlist: [ItemInput!]!
    $promocodes: [String!]!
  ) {
    anonymousLogin(
      basket: $basket
      wishlist: $wishlist
      promocodes: $promocodes
    ) {
      ...LoginResponseFragment
    }
  }
  ${LOGIN_RESPONSE_FRAGMENT}
`

export const REFRESH_TOKEN = gql`
  mutation refreshToken {
    refreshToken {
      status
      token
      ttl
      clientAccess {
        ...ClientAccessFragment
      }
    }
  }
  ${CLIENT_ACCESS_FRAGMENT}
`

export const LOGOUT = gql`
  mutation logout {
    logout {
      status
    }
  }
`

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`

export const RESET_PASSWORD = gql`
  mutation resetPassword($password: String!, $bpToken: String!) {
    resetPassword(password: $password, bpToken: $bpToken)
  }
`

export const GET_PROFILE_ADDRESS = gql`
  query getMyAddresses {
    getMyAddresses {
      ...AddressFragment
    }
  }
  ${ADDRESS_FRAGMENT}
`
export const SAVE_ADDRESS_PROFILE = gql`
  mutation saveMyAddressProfile($address: AddressInput!) {
    saveMyAddressProfile(address: $address) {
      ...AddressFragment
    }
  }
  ${ADDRESS_FRAGMENT}
`

export const UPDATE_ADDRESS_PROFILE = gql`
  mutation updateMyAddressProfile($address: AddressInput!) {
    updateMyAddressProfile(address: $address) {
      ...AddressFragment
    }
  }
  ${ADDRESS_FRAGMENT}
`

export const DELETE_ADDRESS_PROFILE = gql`
  mutation deleteMyAddressProfile($addressKey: String!) {
    deleteMyAddressProfile(addressKey: $addressKey) {
      ...AddressFragment
    }
  }
  ${ADDRESS_FRAGMENT}
`
